<template>
  <span :class="['calc-price', {[`calc-price--size-${size}`]: size}]">
    {{ priceDisplay(num, $hideChange(currency.code)) }}<currency :measure="maesure" :size="size" :symbol="currency.symbol"
                                                  class="calc-price__currency"/>
  </span>
</template>

<script>
  import {is} from "ramda";
  import Currency from "./Currency";
  import priceFormatter from "../mixins/priceFormatter";

  export default {
    name: "Price",
    components: {
      Currency
    },
    mixins: [
      priceFormatter
    ],
    inheritAttrs: false,
    props: {
      hideChange: {
        type: Boolean,
        default: false
      },
      num: {
        type: [Number, String],
        default: 0
      },
      maesure: {
        type: String
      },
      currency: {
        type: Object,
        default: () => ({
          symbol: '#'
        }),
        validate: (v) => !is(v.symbol, String)
      },
      size: {
        type: String,
        default: 'md',
        validate: (v) => ['sm', 'md', 'lg'].includes(v)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .calc-price {
    display: inline-block;
    white-space: nowrap;

    &--size-md {
      font-style: normal;
      font-weight: 500;
      font-size: 1em;
      line-height: 1.5em;
    }

    &--size-lg {
      font-style: normal;
      font-weight: 500;
      font-size: 1.5em;
      line-height: 1em;
    }
  }
</style>
